import _ from 'lodash';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import Image from 'next/image';
import Link from 'next/link';

import Layout from '@/components/layout';

export default function Contact() {
    const router = useRouter();
    let context = _.isEmpty(router.query) ? '' : JSON.stringify(router.query).replace(/\"/ig, ' ') + ' ';

    const [submitted, setSubmitted] = useState(false);
    const [email, setEmail] = useState('kontakt at hyapp');

    useEffect(() => {
        setEmail(process.env.NEXT_PUBLIC_ADMIN_EMAIL);
    }, []);

    async function sendMessage(event) {
        event.preventDefault();
        window.scrollTo(0, 0);

        const res = await fetch('/api/contact', {
            body: JSON.stringify({
                name: event.target.name.value,
                email: event.target.email.value,
                phone: event.target.phone.value,
                message: context + event.target.message.value,
                nix: event.target.nix.value
            }),
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'POST'
        });

        const result = await res.json();
        setSubmitted(result);
    }

    return (
        <Layout title="Kontakt">
            <div className="container">
                <div className="row justify-content-around">
                    <div className="col-12 col-lg-4">

                        <div className="card mt-6">
                            {/* <!-- Body --> */}
                            <div className="card-body">

                                {/* <!-- Image --> */}
                                <div className="avatar avatar-xl card-avatar card-avatar-top mb-3">
                                    <img src="/img/support.png" className="avatar-img rounded-circle border border-4 border-card" alt="..." />
                                </div>

                                {/* <!-- Heading --> */}
                                <h2 className="card-title text-center mb-5">
                                    Kontaktdaten
                                </h2>

                                <div className="list-group list-group-flush">
                                    <div className="list-group-item">
                                        <div className="row align-items-center">
                                            <div className="col">

                                                <small>E-Mail</small>

                                            </div>
                                            <div className="col-auto">

                                                <small className="text-muted">
                                                    <a href={`mailto:${email}`} className="text-muted">{email}</a>
                                                </small>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="list-group-item">
                                        <div className="row align-items-center">
                                            <div className="col">

                                                <small>Telefon</small>

                                            </div>
                                            <div className="col-auto">

                                                <small className="text-muted">
                                                    <a href="tel:+4922196263001" className="text-muted">+49 221 96 26 3001</a>
                                                </small>

                                            </div>
                                        </div>
                                    </div>

                                    <div className="list-group-item">
                                        <div className="row align-items-center">
                                            <div className="col">

                                                <small>Social Media</small>

                                            </div>
                                            <div className="col-auto">

                                                <a href="https://www.xing.com/pages/coinsinformationsystemsag/" className="mr-2" target="_blank" rel="noopener">
                                                    <Image
                                                        src="/img/social/xing.png"
                                                        alt="Xing"
                                                        className=""
                                                        width={22}
                                                        height={22}
                                                    />
                                                </a>
                                                <a href="https://www.linkedin.com/company/logex-de/" target="_blank" rel="noopener">
                                                    <Image
                                                        src="/img/social/linkedin.png"
                                                        alt="LinkedIn"
                                                        className=""
                                                        width={22}
                                                        height={22}
                                                    />
                                                </a>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="col-12 col-lg-6">

                        {/* <!-- Header --> */}
                        <div className="header mt-md-3">
                            <div className="header-body">

                                {/* <!-- Title --> */}
                                <h1 className="header-title display-4">
                                    Sie haben Fragen oder Anregungen?
                                </h1>

                            </div>
                        </div>

                        {(!submitted || submitted.error) &&
                            <form onSubmit={sendMessage}>
                                <p className="mb-5">Wir freuen uns über Ihre Kontaktaufnahme und melden uns zeitnah bei Ihnen.</p>

                                {submitted.error &&
                                    <div className="alert alert-danger" role="alert">
                                        Ein Fehler ist aufgetreten. Bitte überprüfen Sie Ihre Eingabe oder versuchen Sie es später nochmal.
                                    </div>
                                }

                                <div className="form-group">
                                    <label className="form-label" htmlFor="name">Name</label>
                                    <input id="name" className="form-control" name="name" type="text" autoComplete="name" />
                                </div>

                                <div className="form-group">
                                    <label className="form-label" htmlFor="email">E-Mail<span className="text-danger">*</span></label>
                                    <input id="email" className="form-control" name="email" type="email" autoComplete="email" required />
                                </div>

                                <div className="form-group">
                                    <label className="form-label" htmlFor="phone">Telefonnummer</label>
                                    <input id="phone" className="form-control" name="phone" type="tel" autoComplete="phone" />
                                </div>

                                <div className="form-group">
                                    <label className="form-label" htmlFor="message">Nachricht<span className="text-danger">*</span></label>
                                    <textarea id="message" className="form-control" name="message" rows="5" required />
                                </div>

                                <input id="nix" className="d-none" name="nix" type="text" />

                                <div className="row justify-content-between">
                                    <div className="col-6">
                                        <button type="submit" className="btn btn-primary">
                                            Abschicken
                                        </button>
                                    </div>
                                    <div className="col-auto">
                                        <div className="small text-danger">* Erforderlich</div>
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-12">
                                        <p className="text-muted small mb-5">
                                            Bitte beachten Sie bei der Verwendung des Kontaktformulars hinsichtlich der Verarbeitung Ihrer personenbezogenen Daten unsere <Link href="/privacy"><a target="_blank">Datenschutzerklärung</a></Link>.
                                        </p>
                                    </div>
                                </div>

                            </form>
                        }
                        {(submitted && !submitted.error) &&
                            <div className="card">

                                {/* <!-- Body --> */}
                                <div className="card-body text-center">

                                    <div className="card-avatar avatar">
                                        <div className="avatar-title font-size-lg bg-primary-soft rounded-circle text-primary">
                                            <i className="fe fe-check"></i>
                                        </div>
                                    </div>

                                    {/* <!-- Heading --> */}
                                    <h2 className="card-title">
                                        Danke für Ihre Nachricht!
                                    </h2>

                                    {/* <!-- Text --> */}
                                    <p className="small text-muted mb-3">
                                        {/* TODO */}
                                        {/* Lorem ipsum... */}
                                    </p>
                                </div>

                            </div>
                        }
                    </div>
                </div>
            </div>
        </Layout >
    )
}

export async function getStaticProps({ locale }) {
    return {
        props: {
            ...await serverSideTranslations(locale, ['common', 'menu'])
        }
    }
}
